export class ComponentManagerModel {
  history: any;
  params: any;
  appUser: any;
  stats: any;
}
